import { logIn, logInByToken } from '../services/authServices'
import { push } from 'react-router-redux'

export const LOG_IN_REQUEST = 'LOG_IN_REQUEST'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_ERROR = 'LOG_IN_ERROR'
export const LOG_OUT = 'LOG_OUT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'FORGOT_PASSWORD'

export const logInAction = (email, password) => dispatch => {
    dispatch({ type: LOG_IN_REQUEST })
    return logIn(email, password)
        .then(res => {
            let data = res.data;
            dispatch({ type: LOG_IN_SUCCESS, data })
        }).then(() => {
            dispatch(push('/admin'))
        })
        .catch(err => {
            dispatch({ type: LOG_IN_ERROR, err })
        })
}

export const logInByTokenAction = (token) => dispatch => {
    dispatch({ type: LOG_IN_REQUEST })
    return logInByToken(token)
        .then(res => {
            let data = res.data;
            dispatch({ type: LOG_IN_SUCCESS, data })
        }).then(() => {
            dispatch(push('/admin'))
        })
        .catch(err => {
            dispatch({ type: LOG_IN_ERROR, err })
        })
}

export var logOutAction = () => dispatch => {
    return dispatch({ type: LOG_OUT });
}

export var forgotPasswordAction = email => dispatch => {
    return dispatch({ type: FORGOT_PASSWORD, email });
}

export var resetPasswordAction = (email, token) => dispatch => {
    return dispatch({ type: RESET_PASSWORD, email, token });
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js